export default "__VITE_ASSET__03ab42b0__"